var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.357,
    height: 18.251,
    viewBox: "0 0 16.357 18.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1ab395;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M115.228,200.713a.713.713,0,0,0-.713-.713h-7.343a.713.713,0,1,0,0,1.426h7.343A.713.713,0,0,0,115.228,200.713Z",
    transform: "translate(-103.611 -192.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.172,280a.713.713,0,0,0,0,1.426h4.46a.713.713,0,0,0,0-1.426Z",
    transform: "translate(-103.611 -270.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.806,16.826H29.422A1.428,1.428,0,0,1,28,15.4V2.852a1.428,1.428,0,0,1,1.426-1.426h8.765a1.428,1.428,0,0,1,1.426,1.426V7.236a.713.713,0,1,0,1.426,0V2.852A2.855,2.855,0,0,0,38.187,0H29.422A2.855,2.855,0,0,0,26.57,2.852V15.4a2.855,2.855,0,0,0,2.852,2.852h2.384a.713.713,0,1,0,0-1.426Z",
    transform: "translate(-26.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M251.457,272.65a2.141,2.141,0,0,0-3.024,0l-3.914,3.906a.713.713,0,0,0-.179.3l-.852,2.806a.713.713,0,0,0,.873.894l2.878-.8a.712.712,0,0,0,.313-.182l3.906-3.9A2.141,2.141,0,0,0,251.457,272.65Zm-4.781,5.782-1.448.4.424-1.395,2.641-2.635,1.008,1.008Zm3.773-3.766-.138.138L249.3,273.8l.138-.137a.713.713,0,0,1,1.009,1.008Z",
    transform: "translate(-235.726 -262.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.515,120h-7.343a.713.713,0,0,0,0,1.426h7.343a.713.713,0,1,0,0-1.426Z",
    transform: "translate(-103.611 -115.722)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.5b42b6e7.svg";
export { ForwardRef as ReactComponent };